<div class="flex flex-col">
  <div class="flex flex-col my-4">
    <span class="text-xl font-bold">1. ¿Qué datos necesitas?</span>
    <span class="text-md my-3">
      Selecciona el protocolo de consulta que agrupe los datos a los que quieras adherirte. Recuerda que como
      solicitante eres la persona responsable del uso que se hace de los datos que se están consumiendo
    </span>
    <app-search-bar
      [showExternalButton]="true"
      [placeholder]="'Buscar por protocolo o código de organismo'"
      (search)="handleSearch($event)" />
    <app-filters
      class="mt-4"
      [title]="'Buscar por filtros'"
      (applyFilters)="handleApplyFilters($event)"
      [filtersAdvanced]="advancedFilters"
      [containerClass]="'flex flex-row items-end gap-4 flex-wrap'" />
  </div>
  <div class="my-4 font-bold flex justify-between items-center">
    <span>{{ totalResults() }} Protocolos de consulta</span>
  </div>
  @for (item of protocols(); track item.id) {
    <app-description-card
      class="'w-full'"
      [title]="item.protocolName"
      [subtitle]="
        `${item.codigoOrganismoProtocolo} ${getOrganismName(item.codigoOrganismoProtocolo)} | ${item.protocolDepartment}`
      "
      [description]="item.protocolDescription"
      [actions]="item.actions" />
  }
  <app-pagination
    [totalItems]="totalResults()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
